"use client";

import { FormSubTitle } from "@/components/atom/title/form/FormSubTitle";
import ReorderableList from "@/components/molecule/reorderableList/ReorderableList";
import FormTemplate from "@/components/template/form/FormTemplate";
import { COMMON_TEXT } from "@/constants/text";
import { Stack, Text } from "@mantine/core";
import { useState } from "react";

const Reorderable = Object.assign(
  {},
  {
    Template: FormTemplate,
    SubTitle: FormSubTitle,
    List: ReorderableList,
  }
);

export type Item = { id: string; label: string | React.ReactElement };

export function ReorderableListForm({
  initialItems,
  onClick,
}: {
  initialItems: Item[];
  onClick?: (data: Item[]) => void;
}) {
  const [localItems, setLocalItems] = useState<Item[]>(initialItems);

  return (
    <Reorderable.Template onSubmit={() => onClick?.(localItems)}>
      <Stack>
        <Reorderable.SubTitle>
          {COMMON_TEXT.DESCRIPTION.WORK_ORDER_DESC}
        </Reorderable.SubTitle>
        <Reorderable.List<Item>
          items={localItems}
          getId={(it) => it.id}
          render={(it) => <Text>{it.label}</Text>}
          onChange={setLocalItems} // 모달 내부 상태만 변경
        />
      </Stack>
    </Reorderable.Template>
  );
}
